import {isNullOrUndefined} from "../../../../common/utils";
import {TooltipMessage} from "../../../../common/data/TooltipMsg";
import {CloseOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";
import {formatUtcDateToLocal, parseDate} from "../../../../common/utils/TimeUtils";

function RenderIconWithTooltip({children, tooltipMessage}) {
  return (
    <span>
        <Tooltip
          placement="top"
          title={tooltipMessage}
        >
          {children}
        </Tooltip>
    </span>
  );
}

export function excludeMembersColumnGenerator(
  excludedMembers,
  haveMembershipConditionsEditAccess,
  onRemoveMember
) {
  const twoToneColor = "#173d4d";
  let columns = isNullOrUndefined(excludedMembers)
    ? []
    : [
      {
        title: "Business Team members",
        render: (excludedMember) => {
          return (
            <div className="special-condition-member">
              <div className="special-condition-member-first-line">
                <span className="special-condition-member-name">{excludedMember.userName},</span>
                <span className="special-condition-member-employee-id">
                      {excludedMember.userEmployeeId}
                </span>
              </div>
              <div>{excludedMember?.userEmail}</div>
            </div>
          );
        },
      },
      {
        title: "Excluded by",
        dataIndex: "excludedBy",
        key: "excludedBy",
      },
      {
        title: "Excluded on",
        render: (member) => member.excludedOn
          && formatUtcDateToLocal(parseDate(member.excludedOn), "YYYY-MM-DD HH:mm:ss")
      },
      {
        title: "Reason to Exclude",
        dataIndex: "reason",
        key: "reason",
      }
    ];

  if (haveMembershipConditionsEditAccess === true) {
    const ActionsColumnAttribute = {
      title: "Actions",
      key: "actions",
      width: "9%",
      render: (excludedMember) => {
        return (
          <div className="special-condition-action-container">
            <RenderIconWithTooltip tooltipMessage={TooltipMessage.removeExcludeMember}>
              <CloseOutlined
                className="icons"
                twoToneColor={twoToneColor}
                role="button"
                onClick={() => {
                  onRemoveMember(excludedMember.userId)
                }}
              />
            </RenderIconWithTooltip>
          </div>
        );
      },
    };
    columns.push(ActionsColumnAttribute);
  }
  columns.forEach((column) => {
    if (isNullOrUndefined(column.searchEnabled)) {
      column.searchEnabled = false;
    }
    if (isNullOrUndefined(column.sortEnabled)) {
      column.sortEnabled = false;
    }
  });

  return columns;
}

